"use strict";
module.exports = {
    domain: {
        desktop: "pabets-qa.tvg.com",
        mobile: "pabets-qa.tvg.com",
        talentPicks: "pabets-qa.tvg.com/talent-picks/"
    }
};



// WEBPACK FOOTER //
// ./node_modules/@tvg/conf/cjs/content/qa/pabets.js